var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": _vm.maxWidth },
          on: {
            "click:outside": function ($event) {
              return _vm.$emit("cancel")
            },
          },
          model: {
            value: _vm.open,
            callback: function ($$v) {
              _vm.open = $$v
            },
            expression: "open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c("v-card-text", [
                _c("p", { staticClass: "mt-5 mb-0 fs-16 text-center" }, [
                  _vm._v(" " + _vm._s(_vm.message) + " "),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.nameCancel) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                        loading: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("accept")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.nameAccept) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }